import { render, staticRenderFns } from "./selectTag.vue?vue&type=template&id=0f832da1&scoped=true"
import script from "./selectTag.vue?vue&type=script&lang=js"
export * from "./selectTag.vue?vue&type=script&lang=js"
import style0 from "./selectTag.vue?vue&type=style&index=0&id=0f832da1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f832da1",
  null
  
)

export default component.exports